// $http, $rootScope, $compile, $timeout, bsLoadingOverlayService

export default function checkoutGiftsCtrl($scope, $http, $rootScope) {

    $scope.giftClicked = null;
    $rootScope.gift = $scope.gift = null;

    $scope.handleAddGift = function (product) {
        $scope.giftClicked = product;
        if (!$scope.gift) {
            if (Object.keys($scope.giftClicked.sizes).length>1) {
                $scope.openGiftVariantsModal()
            } else {
                $rootScope.gift = $scope.gift = product;
                $scope.pushGiftInSession($scope.gift);
                $scope.giftClicked = null;
            }

        } else {
            $.fancybox.open({
                src: '#gift-remove',
                type: 'inline',
                opts: {
                    // animationEffect: "zoom-in-out",
                    // animationDuration: 500,
                    btnTpl: {
                        smallBtn: `
                        <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
                            <i class="icon-close"></i>
                        </button>
                        `,
                    },
                    // afterClose: function () {}
                },
            });
        }
    }

    $scope.handleRemoveGift = function () {
        if ($scope.giftClicked.id === $scope.gift.id) {
            $rootScope.gift = $scope.gift = null;
            $.fancybox.close();
            $scope.clearGiftInSession();
        } else {
            $rootScope.gift = $scope.gift = null;
            $.fancybox.close();
            $scope.clearGiftInSession();
            $scope.handleAddGift($scope.giftClicked);
        }
    }

    $scope.openGiftVariantsModal = function () {
        $.fancybox.open({
            src: '#gift-variant',
            type: 'inline',
            opts: {
                // clickOutside: false,
                clickSlide: false,
                touch: false,
                // animationEffect: "zoom-in-out",
                // animationDuration: 500,
                btnTpl: {
                    smallBtn: "",
                },
                // afterClose: function () {}
            },
        });
    };

    $scope.selectGiftVariant = function (id, title) {
        $scope.giftClicked.selectedVariant_id = id;
        $scope.giftClicked.selectedVariant_title = title;
    }

    $scope.addGiftWithVariant = function () {
        $rootScope.gift = $scope.gift = $scope.giftClicked;
        $scope.pushGiftInSession($scope.gift);
        $.fancybox.close();
    }

    $scope.pushGiftInSession = function(gift){
        try {
            if( !!$scope.giftClicked.selectedVariant_id){
                gift.selectedVariant_id = $scope.giftClicked.selectedVariant_id
                gift.selectedVariant_title = $scope.giftClicked.selectedVariant_title
            }
        } catch (error) {
            gift.selectedVariant_id = 0; 
            gift.selectedVariant_title = '';
        }
        
        $http({
            method: "POST",
            url: '/' + window.Laravel.code + '/checkout/gift/set',
            data: $rootScope.params(gift), // pass in data as strings
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            } // set the headers so angular passing info as form data (not request payload)
        }).then(function success(response) {
            
        }, function error(response) {
            var data = response.data;
            console.log("Error: ", data);
        });
    }

    $scope.clearGiftInSession = function()
    {
        var gift = {};
        $http({
            method: "POST",
            url: '/' + window.Laravel.code + '/checkout/gift/set',
            data: $rootScope.params(gift), // pass in data as strings
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            } // set the headers so angular passing info as form data (not request payload)
        }).then(function success(response) {
            
        }, function error(response) {
            var data = response.data;
            console.log("Error: ", data);
        });
    }

    // OXI!!!! DEN MOU EKANE KALO AYTO
    // $scope.$watch("gift", function (newValue, oldValue) {
    //     if (typeof newValue !== 'undefined') {
    //         if(!!newValue){
    //             $scope.pushGiftInSession(newValue);
    //         }else{
    //             $scope.clearGiftInSession();
    //         }

    //         console.log(newValue);
    //     }
    // });
}

checkoutGiftsCtrl.$inject = ['$scope', '$http', '$rootScope'];